export default __webpack_public_path__ + "static/media/taravel.531e7366.png";